import { Pages } from 'src/constants/metrics';
import {
  getGroupListing, getThreadDetail, getUserProfileDetail, pagePathMap, BASE_PATH,
} from 'src/constants/pages';

/**
 * @todo remove "/seller-forums" for path once a cumin Link component is developed
 */
export const createProfileHref = (profileId: string) => `${BASE_PATH}/profile/${profileId}`;

/**
 * Get the page from the pathname when react router is not available.
 * Should only be used only when useRouter() cannot be called
 */
export const getPageFromPathname = (pathname: string) => {
  const applicationPathname = pathname.replace(BASE_PATH, '');
  if (applicationPathname === '') return Pages.home;
  let updatedPathname = applicationPathname;

  if (pagePathMap[updatedPathname]) {
    return pagePathMap[updatedPathname];
  }

  // converting dynamic paths to nextjs paths
  [
    {
      pathPrefix: getUserProfileDetail(''),
      nextPathname: getUserProfileDetail('[userId]'),
    },
    {
      pathPrefix: getThreadDetail(''),
      nextPathname: getThreadDetail('[threadId]'),
    },
    {
      pathPrefix: getGroupListing(''),
      nextPathname: getGroupListing('[groupId]'),
    },
  ].forEach((dynamicPath) => {
    if (pathname.includes(dynamicPath.pathPrefix)) {
      updatedPathname = dynamicPath.nextPathname;
    }
  });

  return pagePathMap[updatedPathname] || 'UNKNOWN';
};
